/**
 * Concrete chart colors for the dashboard charts.
 *
 * Chart.js renders to a <canvas> and cannot read CSS custom properties, so the
 * relevant `--lyra-*` tokens from `index.css` are mirrored here as literals.
 * Keep these in sync with the tokens (single dark theme — no multi-theme).
 * Imperative canvas helpers live in `chartHelper.ts`, not here.
 */

export const CHART_COLORS = {
  /* Registrations line — accent orange (--lyra-accent) + soft area fill. */
  accent: "#ff7800",
  accentArea: "rgba(255, 120, 0, 0.10)",
  /* Logins line — warm grey (--lyra-text-secondary) + soft area fill. */
  warm: "#d9c6b6",
  warmArea: "rgba(217, 198, 182, 0.08)",
  /* Axes / grid / tooltip. */
  grid: "rgba(255, 255, 255, 0.06)",
  tick: "#7e746e",
  tooltipBg: "#1b1b1e",
  tooltipBorder: "rgba(255, 255, 255, 0.08)",
  tooltipText: "#feffff",
} as const;
